import React from 'react';
import './style.css';

import { ORG_ID } from 'config';
import { CONTRACT_ORG_MAP } from './constants';

function Contract() {
  const ContractComponent = CONTRACT_ORG_MAP[ORG_ID];
  if (!ContractComponent) {
    return null;
  }
  return <ContractComponent />;
}

export default Contract;
